import React from "react";
import { IconType } from "react-icons";

import styles from "./BonusStatsItem.module.scss";
import { useTheme } from "../../../../common/hooks/useTheme";

interface BonusStatsItemProps {
  icon: IconType;
  title: string;
  value: number;
}

export default function BonusStatsItem({
  icon: Icon,
  title,
  value,
}: BonusStatsItemProps) {
  const { theme } = useTheme();

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.card, borderColor: theme.border }}
    >
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: `${theme.primary}20` }}
      >
        <Icon size={24} color={theme.primary} />
      </div>
      <span className={styles.title} style={{ color: theme.textSecondary }}>
        {title}
      </span>
      <span className={styles.value} style={{ color: theme.text }}>
        {value.toLocaleString("ru-RU")}
      </span>
    </div>
  );
}
